var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-overline"},[_vm._v(_vm._s(_vm.categoryWord))]),_c('h1',[_vm._v(_vm._s(_vm.fandomTitle))]),_c('cardList',{attrs:{"fandom":_vm.fandomTitle,"category":_vm.categoryWord}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }